export default "__VITE_ASSET__aPFKnczn__"